module.exports = __webpack_public_path__ + "img/img4.6c009497.jpg";